import { useEffect, useState } from "react";
const useWindowInnerHeight = ()=>{
    const [windowInnerHeight, setWindowInnerHeight] = useState(0);
    useEffect(()=>{
        const { innerHeight } = window;
        setWindowInnerHeight(innerHeight);
        const updateWindoInnerHeight = ()=>{
            setWindowInnerHeight(window.innerHeight);
        };
        window.addEventListener('resize', updateWindoInnerHeight);
        return ()=>{
            window.removeEventListener('resize', updateWindoInnerHeight);
        };
    }, []);
    return windowInnerHeight;
};
const src_useWindowInnerHeight = useWindowInnerHeight;
export default src_useWindowInnerHeight;
